import React from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Image,
  InputNumber,
  Popconfirm,
  Select
} from "antd";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { SearchOutlined, DeleteOutlined } from "@ant-design/icons";

const { Option } = Select;
// import Quickview from "./Quickview";

// import Addcosting from "./Addcosting";
// import { getSingleProductbystatus } from "../../../actions/singleProductAction";
// import CountVariation from "./CountVariation";
// import CountPrice from "./CountPrice";

var formatter = new Intl.NumberFormat("en-IN");

console.log("rendertable");

class RenderTable extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
    totalPage: 0,
    current: 1,
    minIndex: 0,
    maxIndex: 0,
    selectedRowKeys: [],
    shippingcost: 0,
    totoal_received: 0,
  };

  onSelectChange = (selectedRowKeys) => {
    // console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8, marginTop: -140 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  // selectproduct = () => {
  //   this.props.setselectedproduct(true, this.props.List);
  // };

  handleChange = (page, page_size) => {
    this.props.pageno.current = page;
    this.props.page_size.current = page_size;
    this.props.setUpdatelist(false);
    this.setState({
      current: page,
      minIndex: (page - 1) * this.props.page_size.current,
      maxIndex: page * this.props.page_size.current,
    });
    this.props.setreload(true);
  };

  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const { REACT_APP_API_URL } = process.env;
    const columns = [
      {
        title: "SL",
        key: "index",
        render: (value, item, index) => {
          return index + 1;
        },
      },
      {
        title: "Barcode",
        dataIndex: "barcode",
        key: "barcode",
        // render: (details) => {
        //   console.log(details);
        // },
      },
      {
        title: "Product",
        dataIndex: "Item",
        key: "Item",
        // render: (details) => {
        //   console.log(details);
        // },
      },
      {
        title: "Size",
        dataIndex: "size",
        key: "size",
        // render: (details) => {
        //   console.log(details);
        // },
      },
      
      {
        title: "Batch No",
        dataIndex: "batch_no",
        key: "batch_no",
        // render: (details) => {
        //   console.log(details);
        // },
      },
      
      {
        title: "Quantity",
        key: "quantity",
        render: (text, record, index) => {
          if (
            this.props.List[index].returned != 1 &&
            !this.props.details.returned
          ) {
            return (
              <InputNumber
                min={0}
                defaultValue={this.props.List[index].quantity}
                onChange={(value) => {
                  if (value != null) {
                    this.props.List[index].quantity = value;
                  }
                }}
              ></InputNumber>
            );
          } else {
            return formatter.format(this.props.List[index].quantity);
          }
        },
      },
      {
        title: "Purchase Price",
        dataIndex: "purchase_price",
        key: "purchase_price",
      },

      {
        title: "Min Selling Price",
        dataIndex: "selling_price",
        key: "selling_price",
      },

      {
        title: "Action",
        key: "quantity",
        align: "right",
        render: (text, record, index) => {
          if (
            this.props.List[index].returned != 1 &&
            !this.props.details.returned
          ) {
            return (
              <>
                <DeleteOutlined
                  style={{
                    color: "Red",
                    float: "right",
                    marginTop: "4px",
                  }}
                  onClick={(e) => {
                    
                    this.props
                      .deletePurchaseItemReturn(this.props.List[index].id)
                      .then((rsult) => {
                        this.props.setloading(true);
                        this.props.setrefresh(!this.props.refresh);
                      });
                  }}
                />
              </>
            );
          } else {
            return <>Returned</>;
          }
        },
      },
    ];
    return (
      <Table
        title={() => {
          if (
            this.state.selectedRowKeys.length > 0 &&
            !this.props.details.is_received
          ) {
            let result = [];
            result = this.props.List.filter((el) =>
              this.state.selectedRowKeys.includes(el.id)
            );
            return (
              <>
                <Button
                  type="primary"
                  // size="small"
                  onClick={() => {
                    let promises = [];
                    result.map((item) => {
                      let formData = new FormData();
                      formData.append("quantity", item.quantity);
                      promises.push(
                        this.props.updatePurchaseItemReturn(item.id, formData)
                      );
                    });
                    Promise.all(promises).then((res) => {
                      this.props.setloading(true);
                      this.props.setrefresh(!this.props.refresh);
                    });
                  }}
                >
                  Update
                </Button>

                <Button
                style={{marginLeft: "10px"}}
                  type="primary"
                  // size="small"
                  onClick={() => {
                    let promises = [];
                    result.map((item) => {
                      let formData = new FormData();
                      formData.append("returned", 1);
                      promises.push(
                        this.props.updatePurchaseItemReturn(item.id, formData)
                      );
                    });
                    Promise.all(promises).then((res) => {
                      this.props.setloading(true);
                      this.props.setrefresh(!this.props.refresh);
                    });
                  }}
                >
                  Return
                </Button>
                
              </>
            );
          }
        }}
        rowSelection={rowSelection}
        columns={columns}
        rowKey="id"
        dataSource={this.props.List}
        size="small"
        pagination={{
          defaultPageSize: 500,
        }}
      />
    );
  }
}

export default RenderTable;
